module.exports = __webpack_public_path__ + "img/saudi.9f8bedb4.jpeg";